import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import { ChipProps } from '@material-ui/core/Chip';

interface TruncatedChipProps extends ChipProps {
  tooltipText?: string;
}

const TruncatedChip: React.FC<TruncatedChipProps> = ({ tooltipText, ...chipProps }) => {
  const chipRef = React.useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const labelEl = chipRef.current?.querySelector('.MuiChip-label') as HTMLElement | null;
    if (labelEl) {
      setIsTruncated(labelEl.scrollWidth > labelEl.clientWidth);
    }
  });

  const chip = <Chip ref={chipRef} {...chipProps} />;

  if (isTruncated) {
    return (
      <Tooltip arrow title={tooltipText || (typeof chipProps.label === 'string' ? chipProps.label : '')}>
        <span className="cursor-help">{chip}</span>
      </Tooltip>
    );
  }

  return chip;
};

export default TruncatedChip;
